import { Concat } from '@specs/specs'

export namespace racks {
    export type variation = {
        id: number
        colors?: Array<Concat<'#', string>>
        bg?: string
        price: number
    } // 2

    export const getRackVariation = (variationId: number | null) => variations.find((item) => item.id === variationId) // 4

    export const variations: Array<variation> = [
        // 2
        {
            id: 1,
            colors: ['#CC8080'],
            price: 0
        },
        {
            id: 2,
            colors: ['#CF9777'],
            price: 0
        },
        {
            id: 3,
            colors: ['#DBC387'],
            price: 0
        },
        {
            id: 4,
            colors: ['#AEA768'],
            price: 0
        },
        {
            id: 5,
            colors: ['#9FC681'],
            price: 0
        },
        {
            id: 6,
            colors: ['#79C289'],
            price: 0
        },
        {
            id: 7,
            colors: ['#69A096'],
            price: 0
        },
        {
            id: 8,
            colors: ['#597FA1'],
            price: 0
        },
        {
            id: 9,
            colors: ['#8584C1'],
            price: 0
        },
        {
            id: 10,
            colors: ['#AA7CBF'],
            price: 0
        },
        {
            id: 11,
            colors: ['#E0E0E0'],
            price: 0
        },
        {
            id: 12,
            colors: ['#B9B9B9'],
            price: 0
        },
        {
            id: 13,
            colors: ['#878787'],
            price: 0
        },
        {
            id: 14,
            colors: ['#4D4D4D'],
            price: 0
        }
        // {
        //     id: 5,
        //     bg: 'https://...',
        //     price: 40
        // },
    ]
}
